import React, { useEffect } from 'react';
import { MainTitle } from '../../../../common/index.jsx';
import ExternalUserForm from '../../../../common/External/ExternalUserForm.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import { useTranslation } from 'react-i18next';
import { useSaveExternalUserMutation } from '../../../../../redux/services/externalUsers.jsx';
import { useSearchParams } from 'react-router-dom';
import { Form as AntdForm } from 'antd';

export const ExternalUserRegistrationPage = () => {
  const { successMessage, errorMessage } = useToastMessages();
  const { t } = useTranslation();

  const [
    saveExternalUser,
    {
      data: saveResponse,
      isSuccess: saveExternalUserSuccess,
    },
  ] = useSaveExternalUserMutation();

  useEffect(() => {
    document.title = t('Registrácia externého používateľa');
  }, []); // Runs on mount

  const handleSaveExternalUser = (values) => {
    saveExternalUser({
      body: {
        ...values,
      },
    });
  };

  const [searchParams] = useSearchParams();

  const registrationSource =
    searchParams.get('from') === 'fri-open'
      ? 'fri-open'
      : 'fri-edu';

  const [form] = AntdForm.useForm();

  useEffect(() => {
    if (!saveExternalUserSuccess) return;

    // Some APIs return 200 with logical error { success: false, message: '...' }
    if (
      saveResponse &&
      typeof saveResponse === 'object' &&
      saveResponse.success === false
    ) {
      errorMessage({
        message: t('Uloženie zlyhalo'),
        description: saveResponse.message || t('Nastala neočakávaná chyba.'),
      });
      return; // don't navigate on failure
    }

    // Happy path
    successMessage({
      message: t('Ďakujeme za registráciu!'),
      description: t(
        'Vašu registráciu sme zaznamenali. Na e-mailovú adresu by Vám mal prísť e-mail s URL adresou na nastavenie hesla.',
      ),
    });
    form.resetFields();
  }, [form, saveExternalUserSuccess, saveResponse]);

  return (
    <>
      <MainTitle
        backAction={true}
        title={`Registrácia externého používateľa`}
      />
      <ExternalUserForm
        form={form}
        isCreate={true}
        onSubmit={(values) => handleSaveExternalUser(values)}
        initials={{
          from: registrationSource,
        }}
      />
    </>
  );
};

export default ExternalUserRegistrationPage;
